import React, { useState, ReactElement } from "react";
import { Button } from "./StyledComp";
import "../../Styles/StyledComps.css";

interface IProps {
  buttontext: string;
  isDisabled?: boolean;
  onClick: () => void;
}

const ButtonWithoutIcon: React.FC<IProps> = (props) => {
  const handleOnClick = () => {
    props.onClick();
  };

  return (
    <Button
      className="button-wrapper"
      type="submit"
      onClick={handleOnClick}
      disabled={props.isDisabled}
    >
      <span>{props.buttontext}</span>
    </Button>
  );
};

export default ButtonWithoutIcon;
